export * from './pagination'

const environment: string = import.meta.env.REACT_APP_FLAGS_CTX_APP_NAME || 'production'
export const HEADER_TITLE = `${environment !== 'production' ? environment.toUpperCase() + ' | ' : ''}HowFactory`
